<template>
  <BCard>
    <div class="d-flex align-items-center w-full gap-[.75rem] mb-[1rem]">
      <BButton
        id="filter"
        size="sm"
        variant="primary"
        class="!p-[.6rem]"
        @click="$router.push('/assignment/manage-partners')"
      >
        <span
          class="k-arrow-left-3 text-[16px]"
        />
      </BButton>
      <h5 class="text-[#333333] text-2xl font-semibold mb-0">
        {{ partnerId ? 'Detail' : 'Assign' }} Partner
      </h5>
    </div>
    <BCard>
      <VSelect
        v-if="!partnerDetail.partner_id"
        :options="listPartner"
        :clearable="true"
        placeholder="Cari Nama atau No. Partner"
        :loading="isLoading.partnerList"
        class="w-[25%]"
        @input="onInputSelectPartner"
        @search="(search) => search.length > 0 ? onSearchPartner(search) : ''"
      />
      <div
        v-else
        class="flex justify-between align-items-center"
      >
        <div
          class="flex"
        >
          <img
            :src="partnerDetail.photo_profile_url || 'https://storage.googleapis.com/komerce/assets/avatars/image-null.png'"
            alt="Partner Profile"
            class="size-[45px] object-cover aspect-ratio--1x1 rounded-lg me-[1rem]"
          >
          <div>
            <p class="mb-[.25rem] text-black">
              {{ partnerDetail.partner_name }}
            </p>
            <p class="text-[#737373] truncate m-0">
              No. Partner: {{ partnerDetail.no_partner }}
            </p>
          </div>
        </div>
        <BButton
          v-if="selectedPartner.id"
          variant="light"
          @click="() => {
            selectedPartner = {}
            partnerDetail = {}
          }"
        >
          <div class="inline-block flex items-center">
            <span>Batalkan</span>
          </div>
        </BButton>
      </div>
      <hr class="w-full my-[1.75rem]">
      <div class="grid grid-cols-4">
        <div>
          <p class="text-[#737373] mb-[.5rem]">
            Nomor SK terbaru
          </p>
          <p class="text-black font-medium mb-0">
            {{ partnerDetail.latest_sk_number || '-' }}
          </p>
        </div>
        <div>
          <p class="text-[#737373] mb-[.5rem]">
            Tanggal Mulai
          </p>
          <p class="text-black font-medium mb-0">
            {{ partnerDetail.start_date ? DATE_NUMBER_SLASH(partnerDetail.start_date) : '-' }}
          </p>
        </div>
        <div>
          <p class="text-[#737373] mb-[.5rem]">
            URL SK
          </p>
          <a
            :href="partnerDetail.latest_sk_url || '#'"
            target="_blank"
            class="text-black font-medium mb-0 truncate w-[80%] inline-block"
          >
            {{ partnerDetail.latest_sk_url || '-' }}
          </a>
        </div>
        <div>
          <p class="text-[#737373] mb-[.5rem]">
            File SK
          </p>
          <BButton
            v-if="partnerDetail.latest_sk_number"
            variant="link"
            class="p-0"
            @click="openSKHistory"
          >
            <div class="inline-block flex items-center">
              <feather-icon
                icon="DownloadIcon"
                size="16"
                class="text-[#737373]"
              />
              <span class="ms-[.75rem] underline text-black font-medium">Riwayat SK</span>
            </div>
          </BButton>
          <span v-else>-</span>
        </div>
      </div>
    </BCard>

    <BCard>
      <div class="flex items-center justify-between mb-[1rem]">
        <p class="mb-0 font-medium text-black">
          List Talent Aktif
        </p>
        <BButton
          variant="outline-primary"
          :disabled="!(partnerId || selectedPartner.id)"
          @click="() => openTalentDrawer({ title: TALENT_ACTION.ACTION_ADD })"
        >
          <div class="inline-block flex items-center">
            <span class="k-add scale-110" />
            <span class="ms-[.75rem]">Tambah Talent</span>
          </div>
        </BButton>
      </div>
      <Table
        :items="partnerDetail.active_talents"
        @on-action="({ action, item }) => openTalentDrawer({ title: action, data: item })"
      />
    </BCard>

    <ModalSKHistory
      id="sk-history-modal"
      :partner-id="partnerId || selectedPartner.id"
    />

    <AddOrEditTalentDrawer
      :drawer="talentDrawer"
      @on-close="closeTalentDrawer"
      @on-success-response-action="getPartnerDetail(partnerId || selectedPartner.id)"
    />

    <LogActivityDrawer
      :drawer="logActivityDrawer"
      @on-close="closeLogActivityDrawer"
    />

    <div class="inline-block fixed top-1/2 right-0 rotate-[-90deg] translate-x-[calc(50%-19px)]">
      <BButton
        v-if="partnerId"
        variant="primary"
        size="small"
        class="whitespace-nowrap trigger-btn"
        @click="openLogActivityDrawer"
      >
        LOG ACTIVITY
      </BButton>
    </div>
  </BCard>
</template>

<style scoped>
.btn-primary,
.btn-light,
.btn-outline-primary {
  border-radius: 10px;
}

.trigger-btn.btn-primary {
  border-radius: 10px 10px 0 0 !important;
}
</style>

<script>
import VSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import { DATE_NUMBER_SLASH } from '@/libs/filterDate'
import { komtimAxiosIns } from '@/libs/axios'
import ModalSKHistory from './ModalSKHistory.vue'
import Table from './Table.vue'
import AddOrEditTalentDrawer from './AddOrEditTalentDrawer.vue'
import LogActivityDrawer from './LogActivityDrawer.vue'
import { showError, TALENT_ACTION } from './config'

export default {
  components: {
    VSelect,
    ModalSKHistory,
    Table,
    AddOrEditTalentDrawer,
    LogActivityDrawer,
  },
  data() {
    return {
      TALENT_ACTION,
      partnerDetail: {},
      selectedPartner: {},
      isLoading: {
        partner: false,
        partnerList: false,
      },
      talentDrawer: {
        visible: false,
        id: 'add-or-edit-talent-drawer',
        title: '',
        mode: '',
        data: {},
      },
      logActivityDrawer: {
        id: 'log-activity-drawer',
        visible: false,
        data: {},
      },
      listPartner: [],
    }
  },
  computed: {
    partnerId() {
      return this.$route.params.id
    },
  },
  mounted() {
    if (this.partnerId) this.getPartnerDetail(this.partnerId)
  },
  methods: {
    DATE_NUMBER_SLASH,
    openSKHistory() {
      this.$bvModal.show('sk-history-modal')
    },
    async getPartnerDetail(partnerID) {
      try {
        this.isLoading.partner = true
        const url = `/v1/partner_assignments/${partnerID}`

        const { data: { data } } = await komtimAxiosIns.get(url)
        this.partnerDetail = data
      } catch {
        showError({ title: 'Detail partner gagal dimuat' })
      } finally {
        this.isLoading.partner = true
      }
    },
    onInputSelectPartner(partner) {
      if (partner) {
        this.selectedPartner = partner
        this.getPartnerDetail(partner.id)
      }
    },
    openTalentDrawer({ title, data }) {
      if (!title) return

      this.talentDrawer.title = title
      this.talentDrawer.mode = 'edit'
      if (title.includes('Tambah')) this.talentDrawer.mode = 'add'
      else if (title.includes('Force Off')) this.talentDrawer.mode = 'force-off'
      this.talentDrawer.data = {
        partner_id: this.partnerDetail.partner_id,
        partner_name: this.partnerDetail.partner_name,
        no_partner: this.partnerDetail.no_partner,
        ...data,
      }
      this.talentDrawer.visible = true
    },
    closeTalentDrawer() {
      this.talentDrawer.title = ''
      this.talentDrawer.visible = false
      this.talentDrawer.mode = ''
      this.talentDrawer.data = {}
    },
    openLogActivityDrawer() {
      this.logActivityDrawer.visible = true
      this.logActivityDrawer.data = {
        partnerId: this.partnerId,
      }
    },
    closeLogActivityDrawer() {
      this.logActivityDrawer.visible = false
      this.logActivityDrawer.data = {}
    },
    async getListPartner(keyword) {
      this.offset = 0
      const params = `offset=0&limit=20&status=registered,active,pause,off&keyword=${keyword}`
      const url = `v1/partners?${params}`
      this.isLoading.partnerList = true
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listPartner = data.map(e => ({ ...e, label: `${e.no_partner} - ${e.name}` }))
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.meta?.message
          showError({ title: errorMessage })
          this.loading = false
        })
        .finally(() => {
          this.isLoading.partnerList = false
        })
    },
    searchPartner: _.debounce((search, it) => {
      it.getListPartner(search)
    }, 500),
    onSearchPartner(search) {
      this.searchPartner(search, this)
    },
  },
}
</script>
